import type { ApolloError } from 'apollo-client';
import type { Action } from 'react-sweet-state';
import { createStateHook, createActionsHook, createStore } from 'react-sweet-state';

type OperationalInfoState = {
	closeModal: () => void;
	error?: Error | ApolloError;
	hooksLoading: { [key: string]: boolean };
	loading: boolean;
	skipQuery?: boolean;
};

export const hooksLoading = {
	useGetOSBLink: true,
	useCheckPageInsights: true,
	useCheckPageRestrictions: true,
	useGetNumberOfUsers: true,
	useCheckGuestAccess: true,
};

const initialState: OperationalInfoState = {
	hooksLoading,
	loading: true,
	closeModal: () => {},
};

const actions = {
	setCloseModal:
		(closeModal: () => void): Action<OperationalInfoState> =>
		({ setState }) => {
			setState({ closeModal });
		},
	setError:
		(error: Error | ApolloError): Action<OperationalInfoState> =>
		({ setState }) => {
			setState({ error });
		},
	setHooksLoading:
		(hook: string, loading: boolean): Action<OperationalInfoState> =>
		({ setState, getState }) => {
			const previousHooksLoaded = getState().hooksLoading;
			setState({
				hooksLoading: { ...previousHooksLoaded, ...{ [hook]: loading } },
			});
		},
	setLoading:
		(loading: boolean): Action<OperationalInfoState> =>
		({ setState }) => {
			setState({ loading });
		},
};

const Store = createStore<OperationalInfoState, typeof actions>({
	initialState,
	actions,
});

export const useOperationalInfoActions = createActionsHook(Store);
export const useOperationalInfo = createStateHook(Store);
